import { useRef, useEffect } from "react";

export function useDocumentTitle(title) {
  useEffect(() => {
    document.title = `${title} | Buy Gift Cards Online`;
  }, [title]);
}


